/* eslint camelcase: 0 */

import { Mark as Data } from '@/typings/api/Marks'
import { Model, createMessages } from '@/helpers/Model'


export class MarksModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Загрузить результаты',
    edit: 'Редактировать результаты',
    view: (data: MarksModel) => 'Результаты «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Оценки',
  });
}
